import * as React from 'react';
import { Dropdown, DropdownProps, DropdownItemProps } from 'semantic-ui-react';
import { MessageCategory } from '../../models';

export interface TagsProps {
  messageCategories: MessageCategory[];
  selectedTags: number[];
  onTagSelectionChanged(tagValues: number[]): void;
}

export interface TagsState {
  selectedTags: string | number;
  loading: boolean;
}

export class Tags extends React.Component<TagsProps, TagsState> {

  constructor(props: TagsProps, state: TagsState) {
    super(props, state);
    if (props.selectedTags && props.selectedTags.length) {
      this.state = {
        selectedTags: props.selectedTags[0],
        loading: false,
      };
    } else {
      this.state = {
        selectedTags: '',
        loading: false,
      };
    }
  }

  onChangeTag = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    const selectedTags = data.value as number;
    if (typeof selectedTags !== 'string') {
      this.props.onTagSelectionChanged([selectedTags]);
    }
    this.setState({ selectedTags: data.value as number });
  }

  getTagOptions = () => {
    const options: DropdownItemProps[] = this.props.messageCategories.map(mc => ({
      text: mc.categoryName,
      value: mc.id,
      key: mc.id,
    }));
    return [...options];
  }

  componentWillReceiveProps(nextProps: TagsProps) {
    if (typeof this.state.selectedTags === 'string') {
      const messageCategory = nextProps.messageCategories
        .find(mc => mc.categoryName === this.state.selectedTags);
      if (messageCategory && messageCategory.id) {
        this.setState({ selectedTags: messageCategory.id });
        this.props.onTagSelectionChanged([messageCategory.id]);
   
      }
    }
  }

  renderLabel = (label: DropdownItemProps) => ({
    color: 'blue',
    basic: true,
    content: `${label.text}`,
    id: 'addTag',
  })

  render() {
    return (
      <Dropdown
        placeholder="Select category..."
        fluid={true}
        text={typeof this.state.selectedTags === 'string' ? this.state.selectedTags : undefined}
        multiple={false}
        selection={true}
        value={this.state.selectedTags as number}
        options={this.getTagOptions()}
        labeled={true}
        search={true}
        onChange={this.onChangeTag}
        renderLabel={this.renderLabel}
        closeOnChange={true}
        basic={true}
        id="tagField"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Tags/Tags.tsx